import Trans from "~/modules/translations";
import { NftTypeMiddleware } from "~/middleware/nftTypeMiddleware";
import NavBar from "~/components/navigation/NavBarDesktop.vue";

import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (from.name !== to.name) return { top: 0 };
  },
  routes: [
    {
      path: "/:locale?",
      beforeEnter: Trans.routeMiddleware,
      component: NavBar,
      children: [
        {
          path: "",
          redirect: { name: "Home" },
        },
        {
          path: "zverev",
          name: "zverev",
          component: () => import("@/views/Home/index.vue"),
        },
        {
          path: "home",
          name: "Home",
          component: () => import("@/views/Home/index.vue"),
        },
        {
          path: "terms-and-conditions",
          name: "terms-and-conditions",
          meta: { isLegal: true },
          component: () => import("@/views/Connect/Legal.vue"),
        },
        {
          path: "privacy-policy",
          name: "privacy-policy",
          meta: { isLegal: true },
          component: () => import("@/views/Connect/Legal.vue"),
        },
        {
          path: "cookie-policy",
          name: "cookie-policy",
          meta: { isLegal: true },
          component: () => import("@/views/Connect/Legal.vue"),
        },
        {
          path: "game-rules",
          name: "game-rules",
          meta: { isLegal: true },
          component: () => import("@/views/Connect/Legal.vue"),
        },
        {
          path: "game-scoring",
          name: "game-scoring",
          meta: { isLegal: true },
          component: () => import("@/views/Connect/Legal.vue"),
        },
        {
          path: "academy",
          name: "Academy",
          meta: { isAuth: true },
          component: () => import("@/views/Academy/Academy.vue"),
        },
        {
          path: "fusion",
          name: "Fusion",
          meta: { isAuth: true },
          component: () => import("@/views/Fusion/Fusion.vue"),
        },
        {
          path: "locker",
          name: "locker",
          meta: { isAuth: true },
          children: [
            {
              path: "referral",
              component: () => import("@/views/Referral/ReferralDetails.vue"),
              name: "Referral",
              meta: { isAuth: true },
            },
          ],
        },
        {
          path: "dashboard/trading",
          component: () => import("~/views/Data/Trading.vue"),
          name: "Dashboards",
        },
        {
          path: "blog",
          children: [
            {
              path: "",
              component: () => import("@/views/Blog/Index.vue"),
              name: "Blog",
            },
            {
              path: ":slug",
              component: () => import("@/views/Blog/Post.vue"),
              name: "Post",
            },
          ],
        },
        {
          path: "competitions",
          name: "landing",
          meta: {},
          children: [
            {
              path: "",
              name: "",
              meta: {},
              children: [
                {
                  path: "",
                  name: "Competitions",
                  meta: { isAuth: true },
                  component: () => import("@/views/Tournaments/Competitions.vue"),
                },
                {
                  path: "free-to-play",
                  name: "CompetitionsF2P",
                  meta: { isAuth: true },
                  component: () => import("@/views/Tournaments/Competitions.vue"),
                },
              ],
            },
            {
              path: "select-mode",
              name: "SelectCompetitionMode",
              meta: {},
              component: () => import("@/views/Tournaments/ProF2PSwitch.vue"),
            },
            {
              path: "select-category", // OLD TO BE REMOVED WHEN ADS ARE REMOVED OR UPDATED
              name: "SelectCompetitionMode2",
              meta: {},
              component: () => import("@/views/Tournaments/ProF2PSwitch.vue"),
            },
            {
              path: ":id",
              name: "Subscription",
              component: () => import("@/views/Tournaments/Registration.vue"),
            },
            {
              path: ":id/leaderboard",
              name: "Leaderboard",
              meta: {},
              component: () => import("@/views/Tournaments/Leaderboard.vue"),
            },
          ],
        },
        {
          path: "tennis-player/:slug",
          name: "TennisPlayer",
          component: () => import("@/views/TennisPlayer/TennisPlayer.vue"),
          props: true,
        },
        {
          path: "marketplace",
          redirect: { name: "NewCards" },
          component: () => import("@/views/Marketplaces/Index.vue"),
          name: "Marketplace",
          meta: { infiniteScroll: true },
          children: [
            {
              path: "new-cards/:type?",
              name: "NewCards",
              component: () => import("@/views/Marketplaces/NewCards.vue"),
              beforeEnter: NftTypeMiddleware,
            },
            {
              path: "trade/:type?",
              name: "Trade",
              component: () => import("@/views/Marketplaces/Trade.vue"),
              beforeEnter: NftTypeMiddleware,
            },
          ],
        },
        {
          path: "flash-sale/",
          component: () => import("@/views/Marketplaces/Flashsale.vue"),
          name: "FlashSale",
          meta: {},
        },
        {
          path: "my-deck/:type?",
          component: () => import("@/views/MyDeck/MyDeck.vue"),
          meta: { isAuth: true },
          name: "MyDeck",
          children: [
            {
              path: "",
              name: "MyCards",
              component: () => import("@/views/MyDeck/MyCards.vue"),
            },
            {
              path: "transactions",
              name: "Transactions",
              component: () => import("@/views/MyDeck/Transactions.vue"),
            },
            {
              path: "my-gears",
              name: "MyGears",
              component: () => import("@/views/MyDeck/MyGears.vue"),
            },
          ],
        },
        {
          path: "data",
          name: "Data",
          component: () => import("@/views/Data/Data.vue"),
          redirect: { name: "TennisPlayersTable" },
          children: [
            {
              path: "tennis-players",
              name: "TennisPlayersTable",
              meta: { isAuth: true },
              component: () => import("@/components/data/MainPlayersTable.vue"),
            },
            // {
            //   path: "users",
            //   name: "Users",
            //   component: () => import("@/components/data/MainPlayersTable.vue"),
            // },
            // {
            //   path: "market",
            //   name: "Market",
            //   component: () => import("@/components/data/MainPlayersTable.vue"),
            // },
            {
              path: "dashboard",
              name: "Dashboard",
              component: () => import("~/views/Data/Trading.vue"),
            },
            {
              path: "hall-of-fame",
              name: "hallOfFame",
              component: () => import("~/views/Data/hallOfFame.vue"),
            },
            // {
            //   path: "gameweek",
            //   name: "Gameweek",
            //   component: () => import("@/components/data/MainPlayersTable.vue"),
            // },
          ],
        },
        {
          path: ":pathMatch(.*)*",
          name: "NotFound",
          redirect: { name: "Home" },
        },
      ],
    },
  ],
});

export default router;
